{
  "language": {
    "name": "中文",
    "title": "语言"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 9)}}"
  },
  "button": {
    "auto": "自动",
    "bridge": "跨链",
    "buy": "购买",
    "buyNow": "立即购买",
    "cancel": "取消",
    "connectWallet": "关联钱包",
    "contactSupport": "联系技术支持",
    "continue": "继续",
    "copyAddress": "复制地址",
    "dark": "深色主题",
    "delete": "删除",
    "disconnect": "断开连接",
    "done": "已完成",
    "exchange": "兑换",
    "getGas": "开始兑换燃气费",
    "hide": "隐藏",
    "learnMore": "了解更多",
    "lifiCheckout": "LI.FI 结算",
    "lifiExchange": "LI.FI 兑换",
    "light": "浅色主题",
    "max": "最大",
    "ok": "确认",
    "removeTransaction": "删除交易",
    "reset": "重置",
    "resetSettings": "恢复默认设置",
    "reviewBridge": "查看跨链详情",
    "reviewPurchase": "查看购买详情",
    "reviewSwap": "查看该兑换",
    "seeDetails": "查看详情",
    "showAll": "显示所有",
    "startBridging": "开始跨链",
    "startSwapping": "开始兑换",
    "swap": "兑换",
    "tryAgain": "重试",
    "viewCoverage": "查看我们的覆盖范围",
    "viewOnExplorer": "在区块链浏览器上查看"
  },
  "header": {
    "activeTransactions": "进行中的交易",
    "bridge": "跨链",
    "checkout": "支付",
    "exchange": "兑换",
    "from": "兑换自",
    "gas": "燃气费",
    "payWith": "支付方式",
    "purchase": "购买",
    "purchaseDetails": "交易明细",
    "selectChain": "选择网络",
    "selectWallet": "选择你的钱包",
    "settings": "设置",
    "swap": "兑换",
    "to": "兑换为",
    "transactionDetails": "交易详情",
    "transactionHistory": "交易记录",
    "walletConnected": "连接钱包",
    "youGet": "您获得"
  },
  "info": {
    "message": {
      "autoRefuel": "您在 {{chainName}} 链上的燃气费很低。如果启用该选项，您将获得足够的燃气费完成此次兑换。",
      "emptyActiveTransactions": "正在进行的兑换将在这里显示。一旦完成，你可在兑换记录中找到它们。",
      "emptyTokenList": "我们无法在 {{chainName}} 链上找到这些代币，或者你的钱包内没有这些代币。请再次搜索或者选择其他链再试一次。",
      "emptyTransactionHistory": "交易记录只存储在本地，如果您清除浏览器数据，交易记录将被删除。",
      "routeNotFound": "导致其的原因可能是：流动性低，所选定代币的数额太低，燃气费过高，或者当前没有合适的交易路径。"
    },
    "title": {
      "autoRefuel": "获得燃气费",
      "emptyActiveTransactions": "没有正在进行的交易",
      "emptyTransactionHistory": "近期无交易",
      "routeNotFound": "没有可用的路由"
    }
  },
  "success": {
    "message": {
      "exchangePartiallySuccessful": "我们尝试完成本次交易，但是 {{tool}} 的 {{tokenSymbol}} 代币流动性不足。",
      "exchangeSuccessful": "{{walletAddress}} 钱包在 {{chainName}} 链上收到 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}",
      "purchaseSuccessful": "您的 {{walletAddress}} 钱包在 {{chainName}} 链上拥有该 {{assetName}} 财产"
    },
    "title": {
      "bridgePartiallySuccessful": "跨链部分成功",
      "bridgeSuccessful": "跨链成功",
      "purchaseSuccessful": "购买成功",
      "refundIssued": "退款已受理",
      "swapPartiallySuccessful": "兑换部分完成",
      "swapSuccessful": "兑换成功"
    }
  },
  "warning": {
    "message": {
      "deleteActiveTransactions": "正在进行的交易记录只存储在本地，如果删除它们，我们将无法恢复这些记录。",
      "deleteTransactionHistory": "交易记录只存储在本地，如果你删除它，我们将无法恢复这些记录。",
      "highValueLoss": "收到的代币的价值明显低于要被兑换的代币和交易成本。",
      "insufficientFunds": "你没有足够的资金来完成这笔交易。",
      "insufficientGas": "您没有足够的燃气费来完成此次交易。您至少需要添加：",
      "rateChanged": "兑换比例已经改变，如果继续兑换，您将接受新的兑换比例。",
      "resetSettings": "这将重置您的路由优先级，滑点，燃气费，选中的跨链桥和链上交易所。"
    },
    "title": {
      "deleteActiveTransactions": "确定要删除所有正在进行的交易吗？",
      "deleteTransaction": "确定要删除该交易吗？",
      "deleteTransactionHistory": "确定要清空交易记录吗?",
      "highValueLoss": "大额资金损失",
      "insufficientGas": "燃气费不足",
      "rateChanged": "兑换比例变动",
      "resetSettings": "确定要恢复默认设置吗?"
    }
  },
  "error": {
    "message": {
      "allowanceRequired": "{{tokenSymbol}} 的转账金额超过了您设置的支出上限。请提高该代币的支出上限，然后重试。",
      "insufficientFunds": "您没有足够的燃气费支付该交易。",
      "slippageThreshold": "滑点大于预设值，请选择其他路由并获取新的价格。",
      "transactionFailed": "请查看区块浏览器以了解更多信息。",
      "transactionNotSent": "交易未发送，不用担心，{{chainName}} 链上{{amount, number(maximumFractionDigits: 9)}} 个{{tokenSymbol}} 仍在您的钱包里。",
      "transactionRejected": "需要您签名来完成此次交易，资金是安全的，{{chainName}} 链上{{amount, number(maximumFractionDigits: 9)}} 个{{tokenSymbol}} 仍在您的钱包里。",
      "unknown": "请再试一次或者联系支持。"
    },
    "title": {
      "allowanceRequired": "余额不足",
      "balanceIsTooLow": "余额太低",
      "chainSwitch": "请切换当前网络",
      "gasLimitIsTooLow": "燃气费设置过低",
      "insufficientFunds": "资金不足",
      "slippageNotMet": "滑点未满足",
      "transactionCanceled": "交易取消",
      "transactionFailed": "交易失败",
      "transactionRejected": "交易需要签名",
      "transactionUnderpriced": "交易定价过低",
      "transactionUnprepared": "无法开始该交易",
      "unknown": "未知错误",
      "walletAddressInvalid": "钱包地址无效。",
      "walletAddressRequired": "请输入钱包地址。",
      "walletEnsAddressInvalid": "钱包地址无效或者当前网络不支持ENS。"
    }
  },
  "tooltip": {
    "additionalProviderFee": "跨链和交易所的手续费。",
    "estimatedNetworkFee": "预估网络手续费。",
    "estimatedTime": "预计兑换的执行时间（分钟）。",
    "notFound": {
      "text": "我们找不到这个页面。",
      "title": "404"
    },
    "numberOfSteps": "一系列的兑换步骤，每个步骤可能包含1-2个需要签名的交易。",
    "progressToNextUpdate": "数据将在{{value}} 秒后自动刷新，点击这里可以手动更新。",
    "recommended": "一个价格低廉但是兼顾复杂性和易用性的路由方案。",
    "settingsModified": "设置(已修改)"
  },
  "main": {
    "crossStepDetails": "通过{{tool}}把资产从{{from}}链跨到{{to}}链上",
    "currentAmount": "当前余额",
    "estimatedTime": "{{value}}分钟",
    "featuredTokens": "精选代币",
    "from": "从",
    "fromAmount": "需要支付",
    "gasCost": "燃气费消耗",
    "gasFeeEstimated": "预估燃气费",
    "gasFeePaid": "已支付燃气费",
    "inProgress": "进行中",
    "nftStepDetails": "通过 {{tool}} 购买 NFT",
    "onChain": "在{{chainName}} 上",
    "otherTokens": "其他代币",
    "ownedBy": "属于",
    "process": {
      "crossChain": {
        "actionRequired": "请签署此交易",
        "done": "跨链交易已确认",
        "pending": "跨链交易进行中",
        "started": "准备执行跨链交易"
      },
      "nft": {
        "done": "NFT 已购买"
      },
      "receivingChain": {
        "done": "跨链完成",
        "partial": "跨链部分完成",
        "pending": "等待接收链回应",
        "refunded": "跨链交易资产已退还"
      },
      "swap": {
        "actionRequired": "请签署此交易",
        "done": "兑换完成",
        "pending": "代币兑换中",
        "started": "准备兑换"
      },
      "switchChain": {
        "actionRequired": "请切换当前网络",
        "done": "网络切换成功"
      },
      "tokenAllowance": {
        "done": "已批准代币限额",
        "pending": "代币限额批准进行中",
        "started": "设置代币限额"
      }
    },
    "quotedAmount": "报价金额",
    "rateChange": "波动率",
    "receiving": "接收",
    "refuelStepDetails": "通过 {{tool}} 获取燃气费",
    "selectChain": "选择网络",
    "selectChainAndToken": "选择链和代币",
    "selectToken": "选择代币",
    "sendToAddress": "发送到{{address}}",
    "sendToWallet": "发送到另外的钱包",
    "sending": "发送中",
    "sentToAddress": "发送到{{address}}",
    "stepBridge": "跨链",
    "stepBridgeAndBuy": "跨链并购买",
    "stepDetails": "通过 LI.FI {{tool}}",
    "stepSwap": "兑换",
    "stepSwapAndBridge": "兑换和跨链",
    "stepSwapAndBuy": "兑换并购买",
    "supportId": "支持ID",
    "swapStepDetails": "通过{{tool}}在{{chain}}链上兑换代币",
    "tags": {
      "cheapest": "便宜的",
      "fastest": "快速的",
      "insurable": "可投保",
      "insurance": "保险",
      "insured": "受保中",
      "recommended": "建议的",
      "safest": "最佳/安全"
    },
    "to": "到",
    "tokenOnChain": "{{chainName}}链上的{{tokenSymbol}}",
    "tokenOnChainAmount": "{{chainName}} 链上{{amount, number(maximumFractionDigits: 9)}} 个{{tokenSymbol}}",
    "tokenSearch": "按代币名称或者地址搜索",
    "valueLoss": "资金损失",
    "walletAddressOrEns": "钱包地址或ENS名称"
  },
  "insurance": {
    "bridgeExploits": "跨链桥故障、被黑或者被利用漏洞",
    "insure": "在跨链期间为<0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> 投保。",
    "insured": "在跨链期间为<0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> 投保。",
    "slippageError": "目标链代币的滑点错误"
  },
  "settings": {
    "enabledBridges": "已选中的跨链桥",
    "enabledExchanges": "已选中的交易所",
    "gasPrice": {
      "fast": "快速",
      "normal": "正常",
      "slow": "缓慢",
      "title": "燃气费"
    },
    "routePriority": "路由优先级",
    "showDestinationWallet": "显示收款钱包",
    "slippage": "滑点",
    "resetSettings": "您正在使用自定义设置过滤可用路由。"
  },
  "wallet": {
    "extensionNotFound": "在选择钱包之前，请确保只有{{name}} 浏览器的扩展应用处于激活状态。"
  }
}
